(function(){
document.querySelectorAll('.rf').forEach(function(R){
var NC='https://www.youtube-nocookie.com/embed/';
var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
var save=navigator.connection&&navigator.connection.saveData;
function ifr(id,q,title){var f=document.createElement('iframe');f.src=NC+id+'?'+q;f.title=title||'Ra-Ro';f.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';f.setAttribute('allowfullscreen','');return f;}
if(!reduce&&!save&&R.querySelector('.rf-hv-f')){
var hv=R.querySelector('.rf-hv-f'),tid=R.getAttribute('data-trailer');
var startBg=function(){
var f=ifr(tid,'autoplay=1&mute=1&loop=1&playlist='+tid+'&controls=0&disablekb=1&modestbranding=1&playsinline=1&rel=0&iv_load_policy=3&fs=0','');
f.setAttribute('tabindex','-1');f.setAttribute('aria-hidden','true');hv.appendChild(f);
setTimeout(function(){hv.classList.add('on');var m=R.querySelector('.rf-mute');if(m)m.classList.add('on');},3200);
};
if(document.readyState==='complete')setTimeout(startBg,600);else window.addEventListener('load',function(){setTimeout(startBg,600);});
}
if(R.querySelector('.rf-room')){var room=R.querySelector('.rf-room'),stage=R.querySelector('.rf-stage'),poster=R.querySelector('.rf-stage-p'),pimg=poster.querySelector('img'),
sf=R.querySelector('.rf-stage-f'),items=[].slice.call(R.querySelectorAll('.rf-list [data-i]')),cur=items[0];
var sel=function(b,play){
cur=b;items.forEach(function(x){x.setAttribute('aria-current',x===b?'true':'false');});
var id=b.getAttribute('data-yt');
R.querySelector('.rf-i-t').textContent=b.getAttribute('data-t');
R.querySelector('.rf-i-l').textContent=b.getAttribute('data-l');
R.querySelector('.rf-i-d').textContent=b.getAttribute('data-d');
var pc=R.querySelector('.rf-pieces'),u=b.getAttribute('data-u');if(u){pc.href=u;pc.hidden=false;}else{pc.hidden=true;}
room.classList.toggle('ember',b.getAttribute('data-tone')==='ember');
pimg.dataset.id=id;pimg.src='https://i.ytimg.com/vi/'+id+'/maxresdefault.jpg';
poster.querySelector('.rf-dur').textContent=b.getAttribute('data-dur');
poster.setAttribute('aria-label',b.getAttribute('data-t'));
sf.innerHTML='';poster.hidden=false;
if(play)go();
};
var go=function(){
sf.innerHTML='';sf.appendChild(ifr(cur.getAttribute('data-yt'),'autoplay=1&rel=0&playsinline=1&modestbranding=1',cur.getAttribute('data-t')));poster.hidden=true;
};
poster.addEventListener('click',go);
items.forEach(function(b){b.addEventListener('click',function(){sel(b,true);if(window.innerWidth<1001)stage.scrollIntoView({behavior:reduce?'auto':'smooth',block:'center'});});});
[].forEach.call(R.querySelectorAll('[data-go]'),function(b){b.addEventListener('click',function(){
var t=items[+b.getAttribute('data-go')];sel(t,true);
stage.scrollIntoView({behavior:reduce?'auto':'smooth',block:'center'});
});});
}
if(R.querySelector('.rf-rail')){var rail=R.querySelector('.rf-rail'),bar=R.querySelector('.rf-prog i'),shorts=[].slice.call(R.querySelectorAll('.rf-short'));
var prog=function(){var m=rail.scrollWidth-rail.clientWidth,sl=Math.abs(rail.scrollLeft),w=Math.max(rail.clientWidth/rail.scrollWidth*100,8);
bar.style.width=w+'%';bar.style.insetInlineStart=(m>0?sl/m*(100-w):0)+'%';
var a=R.querySelectorAll('.rf-arr');if(a.length){a[0].disabled=sl<4;a[1].disabled=sl>=m-4;}};
rail.addEventListener('scroll',prog,{passive:true});window.addEventListener('resize',prog);prog();
[].forEach.call(R.querySelectorAll('.rf-arr'),function(a){a.addEventListener('click',function(){
var d=+a.getAttribute('data-dir')*(document.dir==='rtl'?-1:1);rail.scrollBy({left:d*rail.clientWidth*.85,behavior:reduce?'auto':'smooth'});});});
[].forEach.call(R.querySelectorAll('.rf-chip'),function(c){c.addEventListener('click',function(){
var f=c.getAttribute('data-f');
R.querySelectorAll('.rf-chip').forEach(function(k){k.setAttribute('aria-pressed',k===c?'true':'false');});
shorts.forEach(function(s){s.hidden=!(f==='all'||s.getAttribute('data-top')===f);});
rail.scrollLeft=0;prog();
});});
var dlg=R.querySelector('.rf-dlg'),frame=R.querySelector('.rf-frame'),last=null,idx=0;
var vis=function(){return shorts.filter(function(s){return !s.hidden;});};
var load=function(s){frame.innerHTML='';frame.appendChild(ifr(s.getAttribute('data-sy'),'autoplay=1&rel=0&playsinline=1&modestbranding=1&loop=0',s.getAttribute('data-yt-t')));};
var openS=function(s){last=s;var v=vis();idx=v.indexOf(s);load(s);if(dlg.showModal)dlg.showModal();else dlg.setAttribute('open','');dlg.querySelector('[data-close]').focus();};
var step=function(n){var v=vis();idx=(idx+n+v.length)%v.length;last=v[idx];load(last);};
var closeS=function(){frame.innerHTML='';if(dlg.open){if(dlg.close)dlg.close();else dlg.removeAttribute('open');}if(last)last.focus();};
shorts.forEach(function(s){s.addEventListener('click',function(){openS(s);});});
dlg.addEventListener('click',function(e){
if(e.target.closest('[data-close]')||e.target===dlg||e.target.classList.contains('rf-dlg-in')){closeS();return;}
var st=e.target.closest('[data-step]');if(st)step(+st.getAttribute('data-step')*(document.dir==='rtl'?-1:1));
});
dlg.addEventListener('keydown',function(e){if(e.key==='ArrowRight')step(document.dir==='rtl'?-1:1);if(e.key==='ArrowLeft')step(document.dir==='rtl'?1:-1);});
dlg.addEventListener('close',function(){frame.innerHTML='';});
}
});
})();